const REPORTS_CATEGORIES = {
    sales_performance: {
        id: 'sales_performance',
        label: 'reports.labels.categories.sales_performance',
        color: 'teal',
    },
    profitability_and_margins: {
        id: 'profitability_and_margins',
        label: 'reports.labels.categories.profitability_and_margins',
        color: 'purple',
    },
    customer_loyalty: {
        id: 'customer_loyalty',
        label: 'reports.labels.categories.customer_loyalty',
        color: 'orange',
    },
    accounting_and_finance: {
        id: 'accounting_and_finance',
        label: 'reports.labels.categories.accounting_and_finance',
        color: 'coral',
    },
    activity_and_prospecting: {
        id: 'activity_and_prospecting',
        label: 'reports.labels.categories.activity_and_prospecting',
        color: 'yellow',
    },
    global_statistics_and_reporting: {
        id: 'global_statistics_and_reporting',
        label: 'reports.labels.categories.statistics_global_reporting',
        color: 'light-blue',
    },
    custom_report: {
        id: 'custom_report',
        label: 'reports.labels.categories.custom_report',
        color: 'gray',
    },
};

export { REPORTS_CATEGORIES };
